import _objectSpread from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import 'whatwg-fetch';
const UNABLE_TO_PROCESS_REQUEST = 'Unable to process request';
const UNAUTHORIZED = 'UNAUTHORIZED';
let Api = {
  /**
   * Fetch using the GET method
   * @param  {string} endpoint              The endpoint with no beginning slash, example "login" or "login/test"
   * @param  {object} headers               The headers to pass along with call
   * @param  {object} data                  The body data to be passed
   */

  getCookieValue(a) {
    let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  },
  get(apiRoot, endpoint, data, readRequestVerificationTokenHeader, headers) {
    return new Promise((resolve, reject) => {
      let timestamp = Date.now();
      let cachebust = endpoint.indexOf('?') > -1 ? '&_=' + timestamp : '?_=' + timestamp;
      if (headers === undefined) {
        headers = {};
      }
      headers['X-Requested-With'] = 'XMLHttpRequest';
      headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      fetch("".concat(apiRoot).concat(endpoint).concat(cachebust), {
        method: 'GET',
        credentials: 'same-origin',
        headers: headers,
        body: data,
        Pragma: 'no-cache',
        Expires: '0'
      }).then(response => {
        checkOk(response, readRequestVerificationTokenHeader, resolve, reject);
      });
    });
  },
  /**
   * Fetch using the POST method
   * @param  {string} endpoint              The endpoint with no beginning slash, example "login" or "login/test"
   * @param  {object} data                  The body data to be passed
   * @param  {string} csrf                  The csrf token that needs to be sent in custom header
   * @param  {object} headers               The headers to pass along with call
   */

  post(apiRoot) {
    let endpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let data = arguments.length > 2 ? arguments[2] : undefined;
    let csrf = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    let headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    let defaultHeaders;
    if (csrf && csrf.length > 0) {
      defaultHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Request-Verification-Token': csrf,
        'X-Requested-With': 'XMLHttpRequest'
      };
    } else {
      defaultHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      };
    }
    headers = _objectSpread({}, headers, defaultHeaders);
    return new Promise((resolve, reject) => {
      fetch("".concat(apiRoot).concat(endpoint), {
        method: 'POST',
        credentials: 'same-origin',
        headers: headers,
        body: JSON.stringify(data)
      }).then(response => {
        checkOk(response, false, resolve, reject);
      });
    });
  },
  callDelete(apiRoot, endpoint, data, readRequestVerificationTokenHeader, headers) {
    return new Promise((resolve, reject) => {
      let timestamp = Date.now();
      let cachebust = endpoint.indexOf('?') > -1 ? '&_=' + timestamp : '?_=' + timestamp;
      if (headers === undefined) {
        headers = {};
      }
      headers['X-Requested-With'] = 'XMLHttpRequest';
      headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      fetch("".concat(apiRoot).concat(endpoint).concat(cachebust), {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: headers,
        body: data,
        Pragma: 'no-cache',
        Expires: '0'
      }).then(response => {
        checkOk(response, readRequestVerificationTokenHeader, resolve, reject);
      });
    });
  }
};
export class ResponseError extends Error {
  constructor(message, statusCode) {
    super(message);
    this.statusCode = statusCode;
  }
}

// fetch gives a Headers instance, but tests mock this as an Immutable Map or as a
// plain object, and some omit it entirely. Read all three without throwing.
function headerValue(response, name) {
  const headers = response.headers;
  if (!headers) {
    return null;
  }
  if (typeof headers.get === 'function') {
    return headers.get(name);
  }
  return headers[name] != null ? headers[name] : null;
}
function hasJsonBody(response) {
  if (response.status === 204) {
    return false;
  }
  const ct = headerValue(response, 'content-type');
  if (!ct) {
    return true;
  }
  const normalized = String(ct).toLowerCase();
  return normalized.includes('application/json') || normalized.includes('text/');
}
export function checkErrorStatus(response, resolve, reject) {
  // anything above 403 we don't care about json just reject with generic error for 404, 500 etc
  if (response.status > 403) {
    return reject(new ResponseError(UNABLE_TO_PROCESS_REQUEST, response.status));
  }

  // An error page (HTML, or a 204) carries no error message to surface; reject
  // generically rather than failing inside the JSON parse. Same reasoning as
  // hasJsonBody - an unlabelled body is still attempted.
  if (!hasJsonBody(response)) {
    return reject(new ResponseError(UNABLE_TO_PROCESS_REQUEST, response.status));
  }
  response.json().then(json => {
    if (json && json.error && json.error.message) {
      return reject(new ResponseError(json.error.message, response.status));
    } else {
      return reject(new ResponseError(UNABLE_TO_PROCESS_REQUEST, response.status));
    }
  }).catch(ex => {
    return reject(ex);
  });
}
export function checkOk(response, readRequestVerificationTokenHeader, resolve, reject) {
  if (response.ok) {
    if (readRequestVerificationTokenHeader) {
      const requestVerificationHeaderName = 'x-request-verification-token';
      const csrfToken = response.headers.get(requestVerificationHeaderName);
      if (!hasJsonBody(response)) {
        return resolve(true);
      }
      response.json().then(json => {
        if (json) {
          // if 200 has an error property. not ideal but we have to handle old Definitive calls
          if (json.error) {
            handleOkError(json, reject);
          }
          if (typeof csrfToken === 'string') {
            json.csrfToken = csrfToken;
          }
          return resolve(json);
        } else {
          return resolve(true);
        }
      }).catch(ex => reject(ex));
    } else {
      if (!hasJsonBody(response)) {
        return resolve(true);
      }
      response.json().then(json => {
        if (json) {
          if (json.error) {
            handleOkError(json, reject);
          }
          return resolve(json);
        } else {
          return resolve(true);
        }
      }).catch(ex => reject(ex));
    }
  } else {
    return checkErrorStatus(response, resolve, reject);
  }
}
export function handleOkError(jsonResponse, reject) {
  // if 200 has an error property. not ideal but we have to handle old Definitive calls
  const errorMessage = jsonResponse.hasOwnProperty('message') ? jsonResponse.message : jsonResponse.error;
  if (errorMessage && errorMessage.toLowerCase() !== 'internal error occurred') {
    return reject(new Error(errorMessage));
  } else {
    return reject(new Error(UNABLE_TO_PROCESS_REQUEST));
  }
}
export * from './apiRoutes';
export default Api;